import React, { createContext, useContext, useState, ReactNode } from 'react';

interface GoalModalContextType {
  showDailyGoalModal: boolean;
  showStreakGoalModal: boolean;
  openDailyGoalModal: () => void;
  closeDailyGoalModal: () => void;
  openStreakGoalModal: () => void;
  closeStreakGoalModal: () => void;
  // Event emitter for goal updates
  emitGoalUpdate: () => void;
}

const GoalModalContext = createContext<GoalModalContextType | undefined>(undefined);

export const GoalModalProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [showDailyGoalModal, setShowDailyGoalModal] = useState(false);
  const [showStreakGoalModal, setShowStreakGoalModal] = useState(false);

  const openDailyGoalModal = () => setShowDailyGoalModal(true);
  const closeDailyGoalModal = () => setShowDailyGoalModal(false);
  const openStreakGoalModal = () => setShowStreakGoalModal(true);
  const closeStreakGoalModal = () => setShowStreakGoalModal(false);

  const emitGoalUpdate = () => {
    // Dispatch custom event to notify all components
    window.dispatchEvent(new CustomEvent('goalUpdated'));
  };

  return (
    <GoalModalContext.Provider
      value={{
        showDailyGoalModal,
        showStreakGoalModal,
        openDailyGoalModal,
        closeDailyGoalModal,
        openStreakGoalModal,
        closeStreakGoalModal,
        emitGoalUpdate,
      }}
    >
      {children}
    </GoalModalContext.Provider>
  );
};

export const useGoalModal = () => {
  const context = useContext(GoalModalContext);
  if (context === undefined) {
    throw new Error('useGoalModal must be used within a GoalModalProvider');
  }
  return context;
};
